import { render, staticRenderFns } from "./CaixaConfig.vue?vue&type=template&id=5d148bf6&scoped=true&"
import script from "./CaixaConfig.vue?vue&type=script&setup=true&lang=js&"
export * from "./CaixaConfig.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d148bf6",
  null
  
)

export default component.exports